export default __webpack_public_path__ + "static/media/brand.e4dc6493.svg";